import { useEffect, useState } from "react";
import Subscribe from "../../../APIController/Subscribe";
import Form from "../../../Components/Form";
import Text from "../../../Components/Text";
import TextInput from "../../../Components/Form/TextInput";
import NumberInput from "../../../Components/Form/NumberInput";
import RadioButton from "../../../Components/Form/RadioButton";

const SubscriptionForm = ({subscription = null, afterAction}) =>{
    const [id, setId] = useState(null)
    const [name, setName] = useState("")
    const [description, setDescription] = useState("")
    const [useCard, setUseCard] = useState(false)
    const [categoriesCount, setCategoriesCount] = useState(0)
    const [productsPerCategory, setProductsPerCategory] = useState(0)
    const [employeesCount, setemployeesCount] = useState(0)
    const [price, setPrice] = useState(0)
    const [active, setActive] = useState(true)
    const [useLocalConnection, setUseLocalConnection] = useState(false)
    const [createCoupons, setCreateCoupons] = useState(false)
    const [useInventoryManagement, setUseInventoryManagement] = useState(false)
    const [allowTimeTracking, setAllowTimeTracking] = useState(false)
    const[allowCashierUserTracking, setAllowCashierUserTracking]  = useState(false)

    const { createPlan, updatePlan} = Subscribe()

    useEffect(()=>{
        if(subscription){
            setId(subscription.id)
            setName(subscription.name)
            setDescription(subscription.description)
            setUseCard(subscription.useCard)
            setCategoriesCount(subscription.categoriesCount)
            setProductsPerCategory(subscription.productsPerCategory)
            setemployeesCount(subscription.employeesCount)
            setPrice(subscription.price)
            setActive(subscription.active)
            setUseLocalConnection(subscription.useLocalConnection)
            setCreateCoupons(subscription.createCoupons)
            setUseInventoryManagement(subscription.useInventoryManagement)
            setAllowCashierUserTracking(subscription.allowCashierUserTracking)
            setAllowTimeTracking(subscription.allowTimeTracking)
        }
    }, [])

    async function handleSubmit(e){
        e.preventDefault()
        const dto ={
            name: name,
            description: description,
            useCard: useCard,
            categoriesCount: categoriesCount,
            productsPerCategory: productsPerCategory,
            employeesCount: employeesCount,
            price: price,
            active: active,
            useLocalConnection: useLocalConnection,
            createCoupons: createCoupons,
            useInventoryManagement: useInventoryManagement,
            allowCashierUserTracking: allowCashierUserTracking,
            allowTimeTracking: allowTimeTracking
        }
        if(subscription){
            await updatePlan(id, dto)
        }else {
            await createPlan(dto)
        }
        afterAction()
    }

    return(
        <Form onSubmitAction={handleSubmit} submitButtonText={subscription ? "Plan bearbeiten" : "Plan erstellen"}>
            <Text type="maintitle" classNames={"flex text-center justify-center"}>{subscription ? "Plan bearbeiten" : "Plan erstellen"}</Text>
            <TextInput attribute={name} id={"name"} label={"Plan Name"} placeholder={"Super Plan"} action={(e) => setName(e.target.value)} />
            <TextInput attribute={description} id={"description"} label={"Plan Beschreibung"} placeholder={"Viele Funktionen"} action={(e) => setDescription(e.target.value)} />
            {!subscription&&(
                <NumberInput
                    attribute={price}
                    id={"price"}
                    label={"Preis"}
                    action={(e) => setPrice(e.target.value)}
                />
            )}
            <RadioButton 
                attribute1={true} attribute2={false} 
                id={"active"} 
                label1={"Ja"} label2={"Nein"} 
                checked1={active === true} checked2={active === false}
                title={"Aktiv?"}
                action1={() => setActive(true)} action2={() => setActive(false)} />
            <RadioButton 
                attribute1={true} attribute2={false} 
                id={"useLocalConnection"} 
                label1={"Ja"} label2={"Nein"} 
                checked1={useLocalConnection === true} checked2={useLocalConnection === false}
                title={"Lokale Verbindung erlauben"}
                action1={() => setUseLocalConnection(true)} action2={() => setUseLocalConnection(false)} />
            <RadioButton 
                attribute1={true} attribute2={false} 
                id={"createCoupons"} 
                label1={"Ja"} label2={"Nein"} 
                checked1={createCoupons === true} checked2={createCoupons === false}
                title={"Coupons erstellen"}
                action1={() => setCreateCoupons(true)} action2={() => setCreateCoupons(false)} />
            <RadioButton 
                attribute1={true} attribute2={false} 
                id={"useCard"} 
                label1={"Ja"} label2={"Nein"} 
                checked1={useCard === true} checked2={useCard === false}
                title={"Kartenzahlung erlauben"}
                action1={() => setUseCard(true)} action2={() => setUseCard(false)} />
            <RadioButton 
                attribute1={true} attribute2={false} 
                id={"useInventoryManagement"} 
                label1={"Ja"} label2={"Nein"} 
                checked1={useInventoryManagement === true} checked2={useInventoryManagement === false}
                title={"Inventar Management"}
                action1={() => setUseInventoryManagement(true)} action2={() => setUseInventoryManagement(false)} />
            <RadioButton 
                attribute1={true} attribute2={false} 
                id={"allowCashierUserTracking"} 
                label1={"Ja"} label2={"Nein"} 
                checked1={allowCashierUserTracking === true} checked2={allowCashierUserTracking === false}
                title={"Mitarbeiter Login an Kasse möglich"}
                action1={() => setAllowCashierUserTracking(true)} action2={() => setAllowCashierUserTracking(false)} />
            <RadioButton 
                attribute1={true} attribute2={false} 
                id={"allowTimeTracking"} 
                label1={"Ja"} label2={"Nein"} 
                checked1={allowTimeTracking === true} checked2={allowTimeTracking === false}
                title={"Mitarbeiter Time Tracking"}
                action1={() => setAllowTimeTracking(true)} action2={() => setAllowTimeTracking(false)} />
            <NumberInput
                attribute={categoriesCount}
                id={"categoriesCount"}
                label={"Anzahl Kategorien"}
                action={(e) => setCategoriesCount(e.target.value)}
            />
            <NumberInput
                attribute={employeesCount}
                id={"employeesCount"}
                label={"Anzahl Mitarbeiter"}
                action={(e) => setemployeesCount(e.target.value)}
            />
            <NumberInput
                attribute={productsPerCategory}
                id={"productsPerCategory"}
                label={"Anzahl Produkte pro Kategorie"}
                action={(e) => setProductsPerCategory(e.target.value)}
            />
        </Form>
    )
}

export default SubscriptionForm;